import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Button, Checkbox, Dropdown, Field, Groupper, Header, Input, Message, useFrontier } from "react-frontier2";
import { DeliveryMethod, SetLoading, TicketType } from "@arema/components/Classes";
import { bindFormChange } from "@arema/components/Util";
import { DeletedBanner, ErrorHeader, NotFound, UserLog } from "../../components";
import API from "../../API";
import Validator from "@arema/components/Validator";

const TICKET_TYPES = [
	{ id: TicketType.PHYSICAL, name: 'Boleto fisico' },
	{ id: TicketType.DIGITAL, name: 'Boleto digital' },
]

var DeliveryMethodCreate = ()=>{
	var { Toast } = useFrontier();
	var { delivery_id } = useParams();
	var [delivery, setDelivery] = useState<DeliveryMethod>(null);
	var [errorPrompts, setErrorPrompts] = useState<string[]>(null);
	var [loadError, setLoadError] = useState<string>(null);
	var [created, setCreated] = useState<boolean>(null);
	var IS_CREATE = delivery_id === 'create';
	var navigate = useNavigate()

	var loadData = async (delivery_id: number)=>{
		API.getDeliveryMethod(delivery_id).then(res=>{
			if(res.error) return setLoadError(res.message);
			setDelivery({
				...res.data,
				needs_location: !!res.data.needs_location
			});
		}).catch(err=>{
			setLoadError('Hubo un error cargando forma de envío (LCL-DLVCRT-1)');
		});
	}

	useEffect(()=>{
		if(!IS_CREATE && !Number.isNaN(parseInt(delivery_id))){
			loadData(parseInt(delivery_id));
		}else{
			if(delivery) return;
			setDelivery({
				delivery_id: null,
				method_name: '',
				ticket_type: null,
				needs_location: false,
				delivery_cost: null,
			})
		}
	}, []);

	if(!IS_CREATE && Number.isNaN(parseInt(delivery_id))){
		return <NotFound />
	}
	if(loadError){
		return <ErrorHeader error={loadError} />
	}
	if(!delivery){
		return <Header loading text="Cargando forma de envío" />
	}

	var submit = async (setLoading: SetLoading)=>{
		var { valid, prompts } = Validator(delivery, {
			method_name: [{
				rule: 'length', params: [4, 32], label: 'Nombre'
			}],
			delivery_cost: [{
				rule: 'number', label: 'Costo de Envío'
			}],
			ticket_type: [{
				rule: 'number', label: 'Tipo de ticket',
			}]
		});
		setErrorPrompts(prompts);
		if(!valid) return;
		if(!IS_CREATE){
			delivery.delivery_id = parseInt(delivery_id);
		}
		setLoading(true);
		if(IS_CREATE){
			API.createDelivery(delivery.method_name, delivery.ticket_type, delivery.needs_location, delivery.delivery_cost).then(res=>{
				if(res.error) return setErrorPrompts([res.message]);
				setCreated(true);
				Toast.success('Se ha creado la forma de envío');
				setDelivery({
					...delivery,
					delivery_id: res.data.delivery_id
				});
			}).catch(err=>{
				setErrorPrompts(['Hubo un error inesperado creando la forma de envío (LCL-DLVCRT-2)']);
			}).finally(()=>{
				setLoading(false);
			});
		}else{
			API.editDelivery(delivery.delivery_id, delivery.method_name, delivery.ticket_type, delivery.needs_location, delivery.delivery_cost).then(res=>{
				if(res.error) return setErrorPrompts([res.message]);
				Toast.success('Se ha editando la forma de envío');
			}).catch(err=>{
				setErrorPrompts(['Hubo un error inesperado editando la forma de envío (LCL-DLVCRT-3)']);
			}).finally(()=>{
				setLoading(false);
			});
		}
	}

	var onFormChange = bindFormChange(delivery, setDelivery);

	if(IS_CREATE && created){
		return <Groupper title={'Crear forma de envío'} style={{ maxWidth: 500, margin: 'auto' }} fitted>
			<div style={{ minHeight: 310, display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
				<Header text={'Forma de envío creada'} subtext={`Se ha creado la forma de envío #${delivery.delivery_id}`} iconName="check-circle" iconStyle={{ marginBottom: 15 }} style={{ marginTop: 0 }} />
				<Button text="Ver forma de envío" style={{ display: 'block', margin: '0 auto', width: 200, marginTop: 5 }} color="black" as={Link} to={`/c/delivery/${delivery.delivery_id}`} />
			</div>
		</Groupper>
	}

	return <>
		{!!delivery.deleted && <DeletedBanner date_deleted={delivery.date_deleted} />}
		<Groupper title={IS_CREATE ? 'Crear Forma de Envío' : `Editar Forma de Envío`} style={{ maxWidth: 500, margin: 'auto' }} actions={(
			<Button text="Guardar" color="black" onClick={submit} />
		)}>
			<Input label="Nombre" value={delivery.method_name} onChange={onFormChange('method_name')} />
			<Field amount={2}>
				<Dropdown
					value={delivery.ticket_type}
					onValueChange={onFormChange('ticket_type')}
					label='Tipo de boleto'
					items={TICKET_TYPES.map(t=>({
						key: t.id,
						value: t.id,
						text: t.name
					}))}
				/>
				{/* <Field label={'Tipo de boleto'}>
				</Field> */}
				<Input inputType="number" label="Costo de envío" value={delivery.delivery_cost} onChange={onFormChange('delivery_cost')} />
			</Field>
			<Field label={'Necesita ubicación'} comment="Se le pedirá a el cliente que ingrese una dirección">
				<Checkbox label={'Necesita ubicación'} checked={!!delivery.needs_location} onChange={onFormChange('needs_location')} />
			</Field>
			<Message list={errorPrompts} type="error" style={{ marginTop: 15 }} />
		</Groupper>
		{!IS_CREATE && !!delivery && (
			<UserLog user={delivery} />
		)}
	</>
}

export default DeliveryMethodCreate;